<template>
    <!-- <p class="text-xs text-black-900 mb-2 font-light">{{ labelText }}</p> -->
    <div class="events_dropdown mr-2">
        <app-dropdown>
            <app-dropdown-list
                class="!block w-full"
                placement="bottom-start"
                offsetDistance="4"
            >
                <template #dropdownBtn>
                    <div
                        class="events_dropdown__btn"
                        :class="[
                            showResult.length > 0
                                ? '!bg-dark-100 !border-dark-100'
                                : '',
                        ]"
                    >
                        <div class="selected_item">
                            <div class="selected_item_list">
                                <template v-if="showResult.length === 0">
                                    <div
                                        class="text-gray-300 font-medium leading-4"
                                    >
                                        <span>{{ inputHolder }}</span>
                                    </div>
                                </template>
                                <template
                                    v-for="(item, index) in showResult"
                                    :key="index"
                                    v-else
                                >
                                    <!-- {{ item }} -->
                                    <div
                                        class="text-gray-300 font-medium leading-4"
                                        :class="[
                                            showResult.length > 0
                                                ? '!text-white'
                                                : '',
                                        ]"
                                    >
                                        <template v-if="item.icon">
                                            <fa :icon="['fal', item.icon]"></fa>
                                        </template>
                                        <span>{{ item.name }}</span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <fa
                            class="events_dropdown__icon ml-auto"
                            :icon="['fal', 'angle-down']"
                        ></fa>
                    </div>
                </template>
                <template #content="{ close }">
                    <ul>
                        <li class="hover:!bg-transparent">
                            <h3
                                class="text-xs font-bold text-gray-300 uppercase"
                            >
                                {{ filterText }}
                            </h3>
                        </li>

                        <template
                            v-for="(data, index) in eventsArray"
                            :key="index"
                        >
                            <!-- {{ data }} -->
                            <li>
                                <app-search-checkbox
                                    isFull
                                    :name="eventName"
                                    :id="data.id"
                                    :checked="data.isChecked"
                                    :modelValue="data.value"
                                    @update:modelValue="getCheckbox(data.value)"
                                >
                                    <template #checkboxLabel>
                                        <span
                                            class="text-sm font-normal text-dark-100 italic"
                                            >{{ data.name }}</span
                                        >
                                    </template>
                                </app-search-checkbox>
                            </li>
                        </template>
                    </ul>
                </template>
            </app-dropdown-list>
        </app-dropdown>
    </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import AppDropdown from '@/components/dropdown/AppDropdown.vue';
import AppDropdownList from '@/components/dropdown/AppDropdownList.vue';
import AppSearchCheckbox from '../forms/AppSearchCheckbox.vue';
// import { fa } from '@formkit/i18n';
const emit = defineEmits(['checkLabelValue']);
const props = defineProps({
    selectedArray: {
        type: Array,
        default: () => [],
    },
    eventsArray: {
        type: Array,
        default: () => [],
    },
    id: {
        type: String,
        default: 'events',
    },
    allEventId: {
        type: String,
        default: 'allEvents',
    },
    eventName: {
        type: String,
        default: 'events',
    },
    allEventsName: {
        type: String,
        default: 'allEvents',
    },
    labelText: {
        type: String,
        default: '',
    },
    isClose: {
        type: Boolean,
        default: false,
    },
    filterText: {
        type: String,
        default: '',
    },
    inputHolder: {
        type: String,
        default: '',
    },
});
const propArray = computed(() => {
    return props.eventsArray;
});
const showResult = ref([]);
const resetCheckbox = () => {
    showResult.value = [];
    propArray.value.filter((item) => (item.isChecked = false));
};
// const getCheckbox = (value) => {
//     let values = value;
//     showResult.value = [];
//     propArray.value
//         .filter((x) => values.includes(x.value))
//         .map((x) => (x.isChecked = !x.isChecked));
//     showResult.value = propArray.value
//         .filter(function (obj) {
//             return obj.isChecked;
//         })
//         .map(function (obj) {
//             return {
//                 status_id: obj.id,
//                 status: obj.value,
//                 name: obj.name,
//             };
//         });
//     emit('checkStatusValue', showResult.value);
// };
const getCheckbox = (value) => {
    // First, reset all checkboxes
    propArray.value.forEach((item) => {
        item.isChecked = false;
    });

    // Find the selected checkbox and check it
    let selectedCheckbox = propArray.value.find((x) => x.value === value);
    if (selectedCheckbox) {
        selectedCheckbox.isChecked = true;
    }

    // Update the showResult array
    showResult.value = [];
    if (selectedCheckbox) {
        showResult.value.push({
            status_id: selectedCheckbox.id,
            status: selectedCheckbox.value,
            name: selectedCheckbox.name,
        });
    }

    emit('checkStatusValue', showResult.value);
};

defineExpose({ getCheckbox, resetCheckbox });
</script>
<style scoped>
.events_dropdown {
    @apply inline-block;
}

.events_dropdown__btn {
    @apply rounded border border-gray-100 bg-white dark:bg-gray-500 dark:text-white dark:border-black-900 flex items-center h-auto px-3 py-[0.4375rem];
    width: fit-content;
}
.selected_item_list {
    @apply text-black-900 text-sm mr-2;
}
.selected_item_list svg {
    @apply mr-1;
}

.events_dropdown__img {
    @apply w-[2.1875rem] h-auto mr-2;
}

.events_dropdown__text {
    @apply text-sm text-dark-100 mr-3;
}

.events_dropdown__icon {
    @apply text-sm text-gray-500;
}

.events_dropdown__wrapper {
    @apply min-w-[410px] max-w-full bg-white p-4 rounded shadow-dropdown ltr:text-left rtl:text-right;
}

.events_dropdown__countries {
    @apply grid grid-cols-2 md:grid-cols-3 items-center gap-6 border-b border-gray-200 pb-6 mb-6;
}

.events_dropdown__wrapper_btn {
    @apply border border-gray-200 rounded text-center flex flex-col items-center justify-center h-[5rem] dark:bg-black-900;
}

.events_dropdown__wrapper_btn.active {
    @apply border-blue-500;
}

.events_dropdown__wrapper_img {
    @apply max-w-[2.375rem] h-auto;
}

.events_dropdown__wrapper_text {
    @apply text-sm text-dark-200;
}

.events_dropdown__label {
    @apply text-sm text-dark-200 mb-1.5 inline-block;
}

.events_dropdown__select {
    @apply w-full rounded border border-gray-200 bg-gray-100 dark:bg-gray-500 dark:border-black-900 dark:text-white h-10;
}
.events_dropdown__list {
    @apply py-6 first:pt-0 last:pb-0 last:border-b-0 flex items-center border-b border-gray-200 cursor-pointer;
}
.events_dropdown__list > img {
    @apply mr-2;
}
.checkbox {
    @apply w-6 h-6 rounded bg-gray-100 border border-gray-200 flex relative mr-1;
}
li.checked .checkbox::after {
    content: url("data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.9766 0.648438C13.332 0.976562 13.332 1.55078 12.9766 1.87891L5.97656 8.87891C5.64844 9.23438 5.07422 9.23438 4.74609 8.87891L1.24609 5.37891C0.890625 5.05078 0.890625 4.47656 1.24609 4.14844C1.57422 3.79297 2.14844 3.79297 2.47656 4.14844L5.34766 7.01953L11.7461 0.648438C12.0742 0.292969 12.6484 0.292969 12.9766 0.648438Z' fill='black'/%3E%3C/svg%3E");
    @apply absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%];
}
.list_box {
    @apply !p-0;
}
</style>
